<template>
  <div class="flex flex-col max-w-2xl items-center gap-3 mt-3 mx-auto">
    <h1>{{ $t('navigation.faq') }}</h1>
    <div class="flex flex-col gap-3 mb-4 items-center">
      <DirectusErrorView v-if="error" @retry="refresh" :status="status" />
      <div v-for="faq in faqs">
        <div class="flex flex-col gap-2">
          <h2>{{ faq.question }}</h2>
          <div class="answer" v-html="faq.answer"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">

const { getItems } = useDirectusItems();
const showDrafts = ref(useRoute().query.preview);
const platformName = usePlatformSettings().platformName;
const locale = usePlatformSettings().locale;

const stats: string[] = ['published'];
if (showDrafts.value) {
  stats.push('draft');
}

const { data: faqs, error, refresh, status } = await useAsyncData(() => getItems<FAQ>({
  collection: 'd_faq_translations',
  params: {
    fields: ['*', 'd_faq_id.status', '*.*.*'],
    filter: {
      languages_code: locale.value,
      d_faq_id: {
        status: {
          _in: stats
        },
        platform: {
          name: platformName.value
        }
      }
    }
  }
}), {
  watch: locale
});


</script>
<style scoped lang="postcss">
::v-deep(.answer) {
  p {
    @apply leading-relaxed;
  }
}
</style>
